import api from "./api"

const cleanParams = (params = {}) => {
  const result = {}

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value
    }
  })

  return result
}

export const getPayments = async (params = {}) => {
  const response = await api.get("/payments", {
    params: cleanParams(params),
  })

  return response.data
}

export const getPaymentById = async (paymentId) => {
  if (!paymentId) {
    throw new Error("paymentId is required")
  }

  const response = await api.get(`/payments/${paymentId}`)
  return response.data
}

export const getPaymentFormData = async (includeSaleId = null) => {
  const response = await api.get("/payments/form-data", {
    params: cleanParams({
      include_sale_id: includeSaleId,
    }),
  })

  return response.data
}

export const createPayment = async (payload) => {
  const response = await api.post("/payments", payload)
  return response.data
}

export const updatePayment = async (paymentId, payload) => {
  if (!paymentId) {
    throw new Error("paymentId is required")
  }

  const response = await api.put(`/payments/${paymentId}`, payload)
  return response.data
}

export const deletePayment = async (paymentId) => {
  if (!paymentId) {
    throw new Error("paymentId is required")
  }

  const response = await api.delete(`/payments/${paymentId}`)
  return response.data
}